import { useDispatch } from 'react-redux'
import { useState, useEffect } from 'react'

//  Actions
import { actions as profileActions } from 'modules/profile/actions'

// Components
import { Button } from '@tracklib/kit'

// Hooks
import { useProfile } from 'modules/profile/hooks'
import { useRequest } from 'modules/requests/hooks'
import { useIsAuthenticated } from 'modules/auth/hooks'

import styles from './newslettersubscribe.css'

type NewsletterSubscribeProps = {
  onSubscribe?: () => void
}

const NewsletterSubscribe = ({ onSubscribe }: NewsletterSubscribeProps): JSX.Element | null => {
  const [hidden, setHidden] = useState(false)
  const dispatch = useDispatch()
  const isAuthenticated = useIsAuthenticated()
  const profile = useProfile()
  const isUnsubscribed = profile?.is_unsubscribed === null || profile?.is_unsubscribed === true
  const { isLoading: toggleEmailNotificationsRequestIsLoading, isDone: toggleEmailNotificationsRequestIsDone } =
    useRequest('TOGGLE_EMAIL_NOTIFICATION')

  useEffect(() => {
    if (!isAuthenticated || isUnsubscribed === false) {
      return setHidden(true)
    }
    return setHidden(false)
  }, [isAuthenticated, profile.id]) // eslint-disable-line

  useEffect(() => {
    if (toggleEmailNotificationsRequestIsDone && isUnsubscribed === false && onSubscribe) {
      return onSubscribe()
    }
    return () => {
      // do nothing
    }
  }, [toggleEmailNotificationsRequestIsDone, isUnsubscribed]) // eslint-disable-line

  if (hidden) {
    return null
  }

  return (
    <section className={styles.wrapper}>
      <p className={styles.title}>Subscribe to our newsletter</p>
      <p className={styles.description}>
        Get the latest on our beat battle competitions, music catalog news, interviews with artists, labels and producer - and much more.
      </p>
      <Button
        disabled={toggleEmailNotificationsRequestIsLoading}
        variant="white"
        onClick={() => dispatch(profileActions.toggleEmailNotifications(true))}
      >
        {isUnsubscribed ? 'Subscribe' : 'All done!'}
      </Button>
    </section>
  )
}

export default NewsletterSubscribe
